"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const _ = require("underscore");
const core_1 = require("@angular/core");
const devextreme_angular_1 = require("devextreme-angular");
const reporting_service_1 = require("../reporting.service");
require("../Models");
const i0 = require("@angular/core");
const i1 = require("../reporting.service");
const i2 = require("@angular/common");
const i3 = require("devextreme-angular");
const i4 = require("devextreme-angular/ui/nested");
const i5 = require("devextreme-angular/core");
const i6 = require("@angular/forms");
function MtcfsReportComponent_label_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.selectedFacility.name);
} }
function MtcfsReportComponent_select_20_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facility_r10 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", facility_r10);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(facility_r10.name);
} }
function MtcfsReportComponent_select_20_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 26);
    i0.ɵɵlistener("ngModelChange", function MtcfsReportComponent_select_20_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.selectedFacility = $event; })("change", function MtcfsReportComponent_select_20_Template_select_change_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onFacilityChange(); });
    i0.ɵɵtext(1, "\n                    ");
    i0.ɵɵelementStart(2, "option", 27);
    i0.ɵɵtext(3, "All");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "         \n                    ");
    i0.ɵɵtemplate(5, MtcfsReportComponent_select_20_option_5_Template, 2, 2, "option", 28);
    i0.ɵɵtext(6, "                              \n                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.selectedFacility);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.facilities);
} }
function MtcfsReportComponent_dxi_column_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "dxi-column", 29);
    i0.ɵɵtext(1, "\n            ");
    i0.ɵɵelementEnd();
} }
function MtcfsReportComponent_div_68_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 32);
    i0.ɵɵlistener("click", function MtcfsReportComponent_div_68_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r19); const data_r14 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.addEditFeeEffectiveDatesDialog(data_r14.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(data_r14.value);
} }
function MtcfsReportComponent_div_68_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(data_r14.value);
} }
function MtcfsReportComponent_div_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵtemplate(2, MtcfsReportComponent_div_68_a_2_Template, 2, 1, "a", 30);
    i0.ɵɵtext(3, "\n                ");
    i0.ɵɵtemplate(4, MtcfsReportComponent_div_68_p_4_Template, 2, 1, "p", 31);
    i0.ɵɵtext(5, "\n            ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.canModifyResidentFinancial);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.canModifyResidentFinancial);
} }
function MtcfsReportComponent_div_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "DEBTOR");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "NUMBER");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵelementEnd();
} }
function MtcfsReportComponent_div_72_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "MTCF");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "AMOUNT");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵelementEnd();
} }
function MtcfsReportComponent_div_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "MTCF");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "EFFECTIVE DATE");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵelementEnd();
} }
function MtcfsReportComponent_div_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "MTCF FROM LAST");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "MEDICARE STATEMENT");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵelementEnd();
} }
function MtcfsReportComponent_div_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "MTCF EFFECTIVE DATE FROM");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "LAST MEDICARE STATEMENT");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵelementEnd();
} }
class MtcfsReportComponent {
    constructor(reportingService, dialogService, EffectiveDateTypes, facilityService, notificationService, authenticationService, downloadFileService) {
        this.reportingService = reportingService;
        this.dialogService = dialogService;
        this.EffectiveDateTypes = EffectiveDateTypes;
        this.facilityService = facilityService;
        this.notificationService = notificationService;
        this.authenticationService = authenticationService;
        this.downloadFileService = downloadFileService;
        this.initialiseFilters = () => {
            this.reportFilters = {
                facilityId: 0
            };
            this.facilities = this.facilityService.activeUserFacilities.filter(x => x.facilityType == "AgeCare");
            this.canModifyResidentFinancial = this.authenticationService.userPermissions.residentsFinancials.canModify;
            if (this.facilities.length == 1) {
                this.selectedFacility = this.facilities[0];
                this.reportFilters.facilityId = this.selectedFacility.id;
            }
            else {
                this.selectedFacility = null; //Default value for "All"
            }
        };
        this.loadReportData = () => {
            this.reportingService.getMtcfReportData(this.reportFilters).then(result => {
                this.mtcfsReportData = result;
                this.filterredMtcfReportData = result;
                this.totalCount = this.mtcfsReportData.length;
            }, () => {
                this.notificationService.error('Unexpected error occurred while loading report data.');
            });
        };
        this.addEditFeeEffectiveDatesDialog = (data) => {
            if (this.authenticationService.userPermissions.residentsFinancials.canModify) {
                this.selectedRowData = data;
                this.dialogService.openDialog("app/residents/partials/addEditFeeEffectiveDatesDialog.html", "addEditFeeEffectiveDatesDialog.controller", {
                    effectiveDateType: this.selectedRowData.pre2014Care ? this.EffectiveDateTypes.Pre2014IncomeTestedFee : this.EffectiveDateTypes.MeansTestedCareFee,
                    effectiveDates: data.mtcfEffectiveDates,
                    callBack: this.setEffectiveDates,
                    isAdmitted: true,
                    admissionDate: data.admissionDate,
                    isEmptyCollectionValid: false,
                    isFirstValueBasedOnAdmissionDate: true,
                    isIncludeResidentName: true,
                    residentName: data.residentName
                });
            }
        };
        this.setEffectiveDates = (effectiveDateType, effectiveDates) => {
            let mtcfEffective = this.getLatestEffectiveDate(effectiveDates);
            this.selectedRowData.mtcfEffectiveDates = effectiveDates;
            this.selectedRowData.mtcfEffectiveAmount = Number(mtcfEffective.value);
            this.selectedRowData.mtcfEffectiveDate = mtcfEffective.effectiveFromDate;
            let updateMtcfEffectiveDatesDto = {
                facilityId: this.selectedRowData.facilityId,
                pre2014Care: this.selectedRowData.pre2014Care,
                mtcfEffectiveDates: effectiveDates
            };
            this.reportingService.updateMtcfEffectiveDates(this.selectedRowData.residencyId, updateMtcfEffectiveDatesDto)
                .then(() => {
                this.notificationService.success('MTCF has been successfully updated.');
                this.loadReportData();
            }, () => {
                this.notificationService.error('Unexpected error while updating MTCF.');
            });
        };
        this.onFacilityChange = () => {
            if (this.selectedFacility != null) {
                this.reportFilters.facilityId = this.selectedFacility.id;
            }
            else {
                this.reportFilters.facilityId = 0;
            }
            if (this.reportFilters.facilityId == 0) {
                this.filterredMtcfReportData = this.mtcfsReportData;
            }
            else {
                this.filterredMtcfReportData = this.mtcfsReportData.filter(x => x.facilityId == this.reportFilters.facilityId);
            }
            this.totalCount = this.filterredMtcfReportData.length;
        };
        this.getLatestEffectiveDate = (effectiveDates) => {
            var now = moment().startOf('day').utc();
            var item = _
                .chain(effectiveDates)
                .filter(function (item) {
                let effectiveFromDate = moment(item.effectiveFromDate);
                return effectiveFromDate.isSameOrBefore(now, 'day');
            })
                .sortBy('effectiveFromDate')
                .last()
                .value();
            return item;
        };
        this.onCellPrepared = (e) => {
            if (e.rowType == "data") {
                if (e.data.mtcfEffectiveAmount != e.data.mtcfLatestAmount)
                    e.cellElement.className += "unmatched-row";
            }
        };
        this.exportReport = () => {
            this.reportingService.getMtcfsReportExcelStream(this.reportFilters).then((response) => {
                this.downloadFile(response, 'MeansTestedCareFeeComparisonReport.xlsx');
            }, () => {
                this.notificationService.error("Error occurred while exporting MTCF comparison report");
            });
        };
        this.downloadFile = (response, fileName) => {
            this.downloadFileService.downloadFile(response, fileName);
        };
        this.initialiseFilters();
        this.loadReportData();
    }
}
exports.MtcfsReportComponent = MtcfsReportComponent;
MtcfsReportComponent.ɵfac = function MtcfsReportComponent_Factory(t) { return new (t || MtcfsReportComponent)(i0.ɵɵdirectiveInject(i1.ReportingService), i0.ɵɵdirectiveInject('dialog.service'), i0.ɵɵdirectiveInject("EffectiveDateTypes"), i0.ɵɵdirectiveInject('facility.service'), i0.ɵɵdirectiveInject('notification.service'), i0.ɵɵdirectiveInject('authentication.service'), i0.ɵɵdirectiveInject('downloadFile.service')); };
MtcfsReportComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MtcfsReportComponent, selectors: [["mtcf-report"]], viewQuery: function MtcfsReportComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(devextreme_angular_1.DxDataGridComponent, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataGrid = _t.first);
    } }, decls: 83, vars: 19, consts: [["nav-publisher", "reporting", 1, "mtcfs-report"], [1, "col-xs-12"], [1, "page-header"], [1, "col-xs-10", "page-filter"], [1, "col-xs-1"], ["for", "facility", 1, "control-label", "label-facility"], [1, "col-xs-3"], ["class", "control-label v-align-middle", 4, "ngIf"], ["name", "facility", "class", "form-control", 3, "ngModel", "ngModelChange", "change", 4, "ngIf"], [1, "col-xs-2", "export-btn"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "report-table"], ["id", "gridContainer", 3, "dataSource", "showBorders", "showColumnLines", "showRowLines", "allowColumnResizing", "columnAutoWidth", "onCellPrepared"], [3, "enabled"], ["placeholder", "Search...", 3, "visible", "width"], ["dataField", "facilityName", "alignment", "left", "dataType", "string", "width", "140", "caption", "FACILITY", 4, "ngIf"], ["dataField", "residentName", "alignment", "left", "dataType", "string", "width", "155", "caption", "RESIDENT"], ["dataField", "crid", "alignment", "left", "dataType", "string", "width", "75", "caption", "CRID"], ["dataField", "debtorId", "alignment", "left", "dataType", "string", "width", "75", "caption", "DEBTOR NUMBER", "headerCellTemplate", "debtorNumberHeaderTemplate"], ["dataField", "admissionDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "ADMISSION DATE"], ["dataField", "mtcfEffectiveAmount", "alignment", "right", "dataType", "number", "cellTemplate", "mtcfCellTemplate", "width", "75", "caption", "MTCF AMOUNT", "headerCellTemplate", "mtcfAmountHeaderTemplate"], ["dataField", "mtcfEffectiveDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "MTCF EFFECTIVE DATE", "headerCellTemplate", "mtcfEffectiveDateHeaderTemplate"], ["dataField", "mtcfLatestAmount", "alignment", "right", "dataType", "number", "width", "160", "caption", "MTCF FROM LAST MEDICARE", "headerCellTemplate", "mtcfFromLastMedicareHeaderTemplate"], ["dataField", "mtcfLatestDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "MTCF EFFECTIVE DATE FROM LAST MEDICARE", "headerCellTemplate", "mtcfEffectiveDateFromLastMedicareHeaderTemplate"], [4, "dxTemplate", "dxTemplateOf"], [1, "control-label", "v-align-middle"], ["name", "facility", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dataField", "facilityName", "alignment", "left", "dataType", "string", "width", "140", "caption", "FACILITY"], ["href", "javascript:;", "class", "view-value-link margin-right-value-link", 3, "click", 4, "ngIf"], [4, "ngIf"], ["href", "javascript:;", 1, "view-value-link", "margin-right-value-link", 3, "click"]], template: function MtcfsReportComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "\n    ");
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtext(3, "\n        ");
        i0.ɵɵelementStart(4, "h1", 2);
        i0.ɵɵtext(5, "Means tested care fee comparison");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(6, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(7, "\n    ");
        i0.ɵɵelementStart(8, "div", 1);
        i0.ɵɵtext(9, "\n        ");
        i0.ɵɵelementStart(10, "div", 3);
        i0.ɵɵtext(11, "       \n            ");
        i0.ɵɵelementStart(12, "div", 4);
        i0.ɵɵelementStart(13, "label", 5);
        i0.ɵɵtext(14, "Facility");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(15, "\n            ");
        i0.ɵɵelementStart(16, "div", 6);
        i0.ɵɵtext(17, "           \n                ");
        i0.ɵɵtemplate(18, MtcfsReportComponent_label_18_Template, 2, 1, "label", 7);
        i0.ɵɵtext(19, "  \n                ");
        i0.ɵɵtemplate(20, MtcfsReportComponent_select_20_Template, 7, 3, "select", 8);
        i0.ɵɵtext(21, "            \n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(22, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(23, "\n        ");
        i0.ɵɵelementStart(24, "div", 9);
        i0.ɵɵtext(25, "\n            ");
        i0.ɵɵelementStart(26, "button", 10);
        i0.ɵɵlistener("click", function MtcfsReportComponent_Template_button_click_26_listener() { return ctx.exportReport(); });
        i0.ɵɵtext(27, "Export report");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(28, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(29, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(30, "\n\n    ");
        i0.ɵɵelementStart(31, "div", 11);
        i0.ɵɵtext(32, " \n        ");
        i0.ɵɵelementStart(33, "div");
        i0.ɵɵelementStart(34, "strong");
        i0.ɵɵtext(35);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(36, "    \n        ");
        i0.ɵɵelementStart(37, "dx-data-grid", 12);
        i0.ɵɵlistener("onCellPrepared", function MtcfsReportComponent_Template_dx_data_grid_onCellPrepared_37_listener($event) { return ctx.onCellPrepared($event); });
        i0.ɵɵtext(38, "\n\n            ");
        i0.ɵɵelement(39, "dxo-paging", 13);
        i0.ɵɵtext(40, "    \n\n            ");
        i0.ɵɵelement(41, "dxo-search-panel", 14);
        i0.ɵɵtext(42, "\n        \n            ");
        i0.ɵɵtemplate(43, MtcfsReportComponent_dxi_column_43_Template, 2, 0, "dxi-column", 15);
        i0.ɵɵtext(44, "\n            ");
        i0.ɵɵelementStart(45, "dxi-column", 16);
        i0.ɵɵtext(46, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(47, "\n            ");
        i0.ɵɵelementStart(48, "dxi-column", 17);
        i0.ɵɵtext(49, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(50, "\n            ");
        i0.ɵɵelementStart(51, "dxi-column", 18);
        i0.ɵɵtext(52, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(53, "\n            ");
        i0.ɵɵelement(54, "dxi-column", 19);
        i0.ɵɵtext(55, "\n            ");
        i0.ɵɵelementStart(56, "dxi-column", 20);
        i0.ɵɵtext(57, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(58, "\n            ");
        i0.ɵɵelementStart(59, "dxi-column", 21);
        i0.ɵɵtext(60, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(61, "\n            ");
        i0.ɵɵelementStart(62, "dxi-column", 22);
        i0.ɵɵtext(63, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(64, "\n            ");
        i0.ɵɵelementStart(65, "dxi-column", 23);
        i0.ɵɵtext(66, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(67, "\n\n            ");
        i0.ɵɵtemplate(68, MtcfsReportComponent_div_68_Template, 6, 2, "div", 24);
        i0.ɵɵtext(69, "\n\n             ");
        i0.ɵɵtemplate(70, MtcfsReportComponent_div_70_Template, 7, 0, "div", 24);
        i0.ɵɵtext(71, "\n            ");
        i0.ɵɵtemplate(72, MtcfsReportComponent_div_72_Template, 7, 0, "div", 24);
        i0.ɵɵtext(73, "\n            ");
        i0.ɵɵtemplate(74, MtcfsReportComponent_div_74_Template, 7, 0, "div", 24);
        i0.ɵɵtext(75, "\n            ");
        i0.ɵɵtemplate(76, MtcfsReportComponent_div_76_Template, 7, 0, "div", 24);
        i0.ɵɵtext(77, "\n            ");
        i0.ɵɵtemplate(78, MtcfsReportComponent_div_78_Template, 7, 0, "div", 24);
        i0.ɵɵtext(79, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(80, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(81, "\n");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(82, "\n");
    } if (rf & 2) {
        i0.ɵɵadvance(18);
        i0.ɵɵproperty("ngIf", ctx.facilities.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.facilities.length > 1);
        i0.ɵɵadvance(15);
        i0.ɵɵtextInterpolate1("Showing ", ctx.totalCount, " results");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dataSource", ctx.filterredMtcfReportData)("showBorders", true)("showColumnLines", false)("showRowLines", true)("allowColumnResizing", true)("columnAutoWidth", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("enabled", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("visible", true)("width", 240);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.facilities.length > 1);
        i0.ɵɵadvance(25);
        i0.ɵɵproperty("dxTemplateOf", "mtcfCellTemplate");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "debtorNumberHeaderTemplate");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "mtcfAmountHeaderTemplate");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "mtcfEffectiveDateHeaderTemplate");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "mtcfFromLastMedicareHeaderTemplate");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "mtcfEffectiveDateFromLastMedicareHeaderTemplate");
    } }, directives: [i2.NgIf, i3.DxDataGridComponent, i4.DxoPagingComponent, i4.DxoSearchPanelComponent, i4.DxiColumnComponent, i5.DxTemplateDirective, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgModel, i6.NgSelectOption, i6.ɵangular_packages_forms_forms_x, i2.NgForOf], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MtcfsReportComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'mtcf-report',
                templateUrl: './mtcf-report.component.html',
                preserveWhitespaces: true
            }]
    }], function () { return [{ type: i1.ReportingService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['dialog.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ["EffectiveDateTypes"]
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['facility.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['notification.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['authentication.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['downloadFile.service']
            }] }]; }, { dataGrid: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxDataGridComponent, { static: false }]
        }] }); })();
